const isProd = process.env.NODE_ENV === 'production';

export const apiConstants = {
    baseURL: isProd ? window.location.origin + "/api_qr_order/" : "http://localhost/orderpro/api_qr_order/",
    translationCatalogURL: isProd
        ? window.location.origin + "/api_common/ui_translation.php"
        : "http://localhost/orderpro/api_common/ui_translation.php",
};

export const pageConstants = {
    get subFolder() {
        if (typeof window !== 'undefined' && window.location.pathname.startsWith('/qr')) {
            return '/qr';
        }
        return '';
    }
};
